module.exports = __webpack_public_path__ + "img/diru.dfa1deec.png";